import Vue from 'vue'

import UiButton from './src/ui-button'

Vue.component('ui-button', UiButton)

export default UiButton



//////////////////
// WEBPACK FOOTER
// ./~/ui-button/index.js
// module id = 541
// module chunks = 0